"use client";
import Image from "next/image";
import Link from "next/link";

function content({ filteredData }) {
  // Function to scroll to the top of the page
  const scrollTop = () => window.scrollTo({ top: 0, behavior: "smooth" });

  // Helper function to convert month name to a numeric value
  const getMonthNumber = (month) => {
    const months = [
      "Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", 
      "Sep", "Oct", "Nov", "Dec"
    ];
    return months.indexOf(month) + 1; // Adding 1 as months array is 0-indexed
  };

  const sortedData = filteredData.sort((a, b) => {
    const monthA = getMonthNumber(a.date.month); // Convert month name to number
    const monthB = getMonthNumber(b.date.month);

    if (monthA === monthB) {
      return parseInt(b.date.day) - parseInt(a.date.day); // Compare day if months are equal
    }
    return monthB - monthA; // Sort by month in descending order (latest month first)
  });

  return (
    <div className="mx-auto max-w-7xl px-4">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 my-10">
        {sortedData.map((item, index) => (
          <Link href={item.link} onClick={scrollTop} key={index}>
            <div
              key={index}
              style={{ border: "1px solid #2B3252" }}
              className="rounded-2xl min-h-full relative"
            >
              <div className="absolute flex z-10 top-[-20px] left-10">
                <svg
                  width="87"
                  height="70"
                  viewBox="0 0 87 70"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M13.5 0H86.5L73 20H0L13.5 0Z" fill="#9E8228" />
                  <path d="M14 0H86V70H14V0Z" fill="#D5AF34" />
                </svg>

                <div className="absolute flex flex-col items-center top-[10px] left-[35px]">
                  <span className="text-xl font-bold text-[#2B3252]">
                    {item.date.day}
                  </span>
                  <br />
                  <span className="mt-[-26px]">{item.date.month}</span>
                </div>
              </div>

              <div className="p-3">
                <div className="relative">
                  <Image
                    src={item.image}
                    alt="Car Service"
                    width={600}
                    height={400}
                    className="w-full rounded-2xl"
                  />
                </div>

                <div className="text-[#2B3252]">
                  <div className="bg-[#E9EDFF] font-base font-normal mt-3 px-2 py-1 rounded-md inline-block mb-2">
                    {item.title}
                  </div>
                  <h3 className="text-xl font-bold mb-2">{item.description}</h3>
                </div>
              </div>
            </div>
          </Link>
        ))}
      </div>
      <div className="flex justify-center mb-4 mt-2">
        {/* <button
          style={{ border: "1px solid #2B3252" }}
          className="pl-3 text-[#2B3252] pr-3 pt-1 pb-1 rounded"
        >
          View More
        </button> */}
      </div>
    </div>
  );
}

export default content;
